<template>
  <div class="flex flex-row border-b-4 border-purple h-10 items-center">
    <div class="flex flex-row items-center">
      <print-icn width="20px" height="20px" class="ml-2 mr-2" fill="#A068E0" fill-rule="evenodd"></print-icn>
      <span class="text-purple font-bold" style="font-size: 18px; line-height: 1;">印刷データ</span>
    </div>
    <app-download-searche
      class="top-0.5 my-0 mx-auto"
      color="purple"
      v-show="isShow"
    ></app-download-searche>
  </div>
</template>

<script>
import { computed } from 'vue'
import PrintIcn from '@/assets/icons/print.svg?inline'
import AppDownloadSearche from '@/components/ui/AppDownloadSearche'
import { useCurrentUser } from '@/services/useCurrentUser'

export default {
  name: 'DownloadsTableHeader',

  components: {
    PrintIcn,
    AppDownloadSearche,
  },

  setup(){
    const { currentUser } = useCurrentUser()
    const isShow = computed(() => {
      if(currentUser.role.is_office_worker){
        return true
      } else {
        return false
      }
    })
    return { isShow }
  },
}
</script>
